import {compose} from "redux"
import React from "react";
import _ from "lodash"
import PropTypes from "prop-types";
import { withStyles,Paper,List,ListItem,ListItemSecondaryAction,Grid,ListItemText,Avatar,IconButton,Divider} from "@material-ui/core";
import {Button} from "../../components"
import { withFirestore,firestoreConnect,isLoaded } from 'react-redux-firebase'
import { connect } from 'react-redux'
import {primaryColor} from "../../assets/jss/material-dashboard-react"
import GroupIcon from "@material-ui/icons/Group"
import EditIcon from "@material-ui/icons/Edit"
import {LoadingSpinner, NewSurveyTile} from "../../components"

class Organisations extends React.Component {


    state={
        isCreating:false
    }


    createOrganisation=()=>{
        const {firestore,history} = this.props
        this.setState({isCreating:true})
        firestore.add('organisations',{}).then((result)=>{
            history.push(`/organisation/${result.id}/edit`)
        })

    }

    navEditOrganisation=(orgId)=>{
        const {history} = this.props
        history.push(`/organisation/${orgId}/edit`)
    }

    navViewOrganisation=(orgId)=>{
        const {history} = this.props

        history.push(`/organisation/${orgId}/view`)
    }

    render(){

        const {classes,organisations,firestore} = this.props

        console.log(firestore)

        const {isCreating} = this.state

        return(
            <div className={classes.root} style={{display:"block"}}>

            <div>
                <div className={classes.sectionHeader}>
                    <h3 style={{marginTop:40,marginLeft:20,color:"rgb(85, 85, 85)",fontSize: 20,fontWeight:600}}>Create a new organisation</h3> 
                </div>
                <div  style={{height: 180}} >
                        <Grid item>
                                <NewSurveyTile onClick={this.createOrganisation}/>
                        </Grid>
                </div>
           </div>  

            <div style={{marginLeft:20,marginTop:20,marginBottom:20}} className={classes.sectionHeader}>
                <h3 style={{color:"rgb(85, 85, 85)",fontSize: 15,fontWeight:600}}>Current organisations</h3> 
                <Divider/>            
            </div>
                <div style={{justifyContent:"center"}}>
                    <Paper className={classes.container} style={{width:"80%",marginLeft:20}}>
                        <div className={classes.listContainer}>
                        <List className={classes.list}>
                                {_.map(organisations,(organisation,key)=>{

                                    console.log(organisation.avatarUrl)

                                    return (
                                        <ListItem divider key={key} dense button className={classes.listItem} onClick={()=>{this.navViewOrganisation(organisation.id)}}>
                                            <Avatar style={{backgroundColor:"white",boxShadow: "rgba(0, 0, 0, 0.28) 0px 1px 3px 0px, rgba(0, 0, 0, 0.12) 0px 2px 8px 1px, rgba(0, 0, 0, 0.2) 0px 1px 1px 0px"}}>
                                                  {organisation.avatarUrl?<img src={organisation.avatarUrl} width="35"></img>:<GroupIcon style={{color:"gray"}}/>}
                                            </Avatar>
                                            <ListItemText primary={organisation.name?organisation.name:"Untitled Organisation"} />
                                            {/* <ListItemSecondaryAction>
                                                <IconButton color="primary" onClick={()=>{this.navEditOrganisation(organisation.id)}} aria-label="Edit Organisation">
                                                    <EditIcon/>
                                                </IconButton>
                                            </ListItemSecondaryAction> */}
                                        </ListItem>
                                    );
                                })}
                        </List>
                        </div>
                    </Paper>
                </div>

            </div>
        )
    }
}

const styles ={
    root:{
        display:"flex",
        justifyContent:"center",
        marginTop:20
    },
    container:{
        minWidth:300,
        padding:20,
    },
    header:{
        display:"flex",
      justifyContent:"flex-end"

    },
    table:{

    },
    listContainer:{
        display:"flex",
        justifyContent:"center",
        alignItems:"center"
    },
    list:{
        width:"100%",
        minWidth:200
    },
    links:{
        color:primaryColor
    }


}

export default compose(
    withFirestore,
    withStyles(styles),
    firestoreConnect((props) =>{
        return([{
            collection: "organisations",
        }])
    }),
    connect((state)=>{
        return {
            organisations: state.firestore.ordered.organisations,
        }
    })
)(Organisations)


// WEBPACK FOOTER //
// ./src/views/Organisations/Organisations.jsx